import { render, staticRenderFns } from "./NewVehicle.template.vue?vue&type=template&id=bba690c0&scoped=true&"
var script = {}
import style0 from "./NewVehicle.template.vue?vue&type=style&index=0&id=bba690c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba690c0",
  null
  
)

export default component.exports